/* eslint-disable eqeqeq */
// components/Counter.tsx
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./GuestSlotsNew.scss";
import { bindActionCreators } from "redux";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Skeleton } from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import { useTranslation, withTranslation } from "react-i18next";
import { actionCreators } from "../../../../store";
import { RootState } from "../../../../store/reducers";
import { apiService } from "../../../../services";
import { getDateForDayOfWeek } from "../../../../helper/dates";
import FreezScreen from "../../../../components/FreezScreen";
import { get_lang } from "../../../../helper/getLang";
import BasicDatePicker from "../../../../components/dataPicker/DatePicker";
import { convertTo12HourFormat } from "../../../../utils/genral-functions";
import NewNextBtn from "../../../../components/BtnNext/NewNextBtn";
import { getLang } from "../../../../helper/global";
import BookingStepSection from "./BookingStepSection";
import SelectionChipGrid from "./SelectionChipGrid";

const GuestSlotsNew = (props: any) => {
  const { slotsList, times, excludedDates=null , setGetSeletedDateByUSer, maxDays=0} = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { setBookingForm, alertMessageState, setCart } = bindActionCreators(
    actionCreators,
    dispatch
  );
  const state = useSelector((state: RootState) => state.appReducer);
  const { langValue, bookingForm } = state;
  const appState = useSelector((state: RootState) => state.apiReducer);
  const { bookingDetails } = appState;
  const navigate = useNavigate();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const [bId, setBId] = useState(searchParams.get("bId"));
  const { slug } = useParams();
  const [routeLoading, setRouteLoading] = useState(false);
  const [value, setValue] = useState(0);
  const [subTotalGuest, setSubTotalGuest] = useState([]);
  const [timeValue, settimeValue] = useState(-1);
  const [apiLoading, setApiLoading] = useState(false);
  const [selectionType, setSelectionType] = useState(1);
  const [startAt, setStartAt]: any = useState("");
  const [endAt, setEndAt]: any = useState("");
  const [days, setDays] = useState([]);
  const [slots, setSlots] = useState([]);
  const [guest, setGuest] = useState([
    {
      id: `1_id`,
      name: `1 Guest`,
      value: 1,
    },
  ]);
  const [hasExtras, sethHsExtras] = useState(false);
  const [formFields, setFormFields]: any = useState({
    NoGuest: 0,
    bookingTime: null,
    bookingDayObj: null,
    bookingDate: null,
    checkBoxDate: null,
    currentSelectedDate: null,
    validDate: true,
  });
  const [initalMount, setInitalMount] = useState(true);
  const [selectedDate, setSelectedDate] = React.useState<Date | null>(null);
  const [selectDateCheckBox, setSelectDateCheckBox] = React.useState<
    Date | any
  >([]);

  // Function to handle date change
  const handleDateChange = (date: Date | null | any, validDate: boolean = true) => {
    console.log(date, validDate, 'handleDateChange')
   

    let moment = require("moment");
    let dateFormat = new Date(date);
    let selectedDayOfWeek: any;
    let newGuest: any = [];
    // Set initial min and max values
    let min: number = 1;
    let max: number = 1;
    // Format the date as "3/10/2024"
    // Format the date as "29-03-2024"
    const formattedDate = moment(dateFormat).format("YYYY-MM-DD");
    // Get the day of the month
    const selectedDayOfMonth = dateFormat.getDate(); // Example: 10
    // Update min and max based on the current guest state
    if (guest.length > 0) {
      min = guest[0].value;
      max = guest[guest.length - 1].value;
    }

    setSelectedDate(date);
    if (dateFormat) {
      const options: any = { weekday: "long" };
      selectedDayOfWeek = dateFormat.toLocaleString("en-US", options); // Day of the week as a string (e.g., "Monday", "Tuesday", etc.)
    }
    if (selectionType === 1) {
      let findDay: any = days.find(
        (item: any) => item.day === selectedDayOfWeek
      );
      setFormFields({
        ...formFields,
        bookingDayObj: findDay,
        bookingDate: formattedDate,
        checkBoxDate: date,
        currentSelectedDate: date,
        validDate: validDate,
      });
      console.log("setGetSeletedDateByUSer", date);
      setGetSeletedDateByUSer(date);
    } else if (selectionType === 2) {
      let findDay: any = days.find(
        (item: any) => item.day === selectedDayOfWeek
      );
      if (findDay) {
        // Update max if maxGuest is less than the current max
        if (findDay.maxGuest != max || findDay.minGuest != min) {
          max = findDay.maxGuest;
          min = findDay.minGuest;
          // Iterate from min to max
          newGuest = handleCustomGuest(min, max);
          // Update guest state
          // setGuest(newGuest);
          // Update formFields if necessary
          if (formFields.NoGuest > max) {
            setFormFields({
              ...formFields,
              NoGuest: findDay.maxGuest,
              validDate: validDate,
            });
          }
          if (formFields.NoGuest < min) {
            setFormFields({
              ...formFields,
              NoGuest: min,
              validDate: validDate,
            });
          }
        }
        setFormFields({
          ...formFields,
          bookingDayObj: findDay,
          bookingDate: formattedDate,
          checkBoxDate: date,
          currentSelectedDate: date,
          validDate: validDate,
        });
        console.log("setGetSeletedDateByUSer", date);
        setGetSeletedDateByUSer(date);
      }
    } else if (selectionType === 3) {
      // Handle selection type 3
      let findDay: any = days.find(
        (item: any) => item.day == selectedDayOfMonth
      );

      if (findDay) {
        // Update max if maxGuest is less than the current max
        if (findDay.maxGuest != max || findDay.minGuest != min) {
          max = findDay.maxGuest;
          min = findDay.minGuest;

          // Iterate from min to max
          newGuest = handleCustomGuest(min, max);
          // Update guest state
          // setGuest(newGuest);
          // Update formFields if necessary
          if (formFields.NoGuest > max) {
            setFormFields({
              ...formFields,
              NoGuest: findDay.maxGuest,
              validDate: validDate,
            });
          }
          if (formFields.NoGuest < min) {
            setFormFields({
              ...formFields,
              NoGuest: findDay.minGuest,
              validDate: validDate,
            });
          }
          setFormFields({
            ...formFields,
            bookingDayObj: findDay,
            bookingDate: formattedDate,
            checkBoxDate: date,
            currentSelectedDate: date,
            validDate: validDate,
          });
          console.log("setGetSeletedDateByUSer", date);
          setGetSeletedDateByUSer(date);
        } else {
          setFormFields({
            ...formFields,
            bookingDayObj: findDay,
            bookingDate: formattedDate,
            validDate: validDate,
          });
        }
      }
    }
  };

  const handleDiscount = (discount: any, price: any) => {
    let discountAmount: any = discount?.amount ?? 0;
    let actualAmount: any = Number(price) - Number(discountAmount);
    return Number(actualAmount);
  };

  const handleNext = () => {
    let form: any = { ...formFields };
    console.log(form, 'form')
    setRouteLoading(true);
    let bookingCategory = bookingDetails.find(
      (item: any) => item.id == Number(bId)
    );
    slots.forEach((ele: any) => {
      console.log(ele)
      let bookedTime: any = form?.bookingTime?.id;
      let bookedDayId: any = form?.bookingDayObj?.id ?? null;
      let dayId: any = ele?.day?.id ?? null;
      let slotPrice: any = 0;
      console.log(selectionType, bookedTime);
      if (selectionType == 1) {
        form = {
          ...form,
          slotPrice: slotPrice,
          slotId: ele?.id,
          hasGuestPricing: ele?.has_guest_pricing,
          bookingType: selectionType,
          bookingPrice: bookingCategory?.price,
          bookingDayObj: null,
        };
        console.log({
          ...form,
          slotPrice: slotPrice,
          slotId: ele?.id,
          hasGuestPricing: ele?.has_guest_pricing,
          bookingType: selectionType,
          bookingPrice: bookingCategory?.price,
          bookingDayObj: null,
        });
      } else if (selectionType == 2 ) {
        form = {
          ...form,
          slotPrice: slotPrice,
          slotId: ele?.id,
          hasGuestPricing: ele?.has_guest_pricing,
          bookingType: selectionType,
          bookingPrice: bookingCategory?.price,
        };
      } else if (selectionType == 3 ) {
        form = {
          ...form,
          slotPrice: slotPrice,
          slotId: ele?.id,
          hasGuestPricing: ele?.has_guest_pricing,
          bookingType: selectionType,
          bookingPrice: bookingCategory?.price,
        };
      }
    });
    if (!form.validDate) {
      alertMessageState({
        type: "error",
        show: true,
        message: getLang({en: "Please select a valid date", ar: "يرجى تحديد تاريخ صالح."}, langValue),
      });
      return;
    }
    if (form.NoGuest < 1) {
      alertMessageState({
        type: "error",
        show: true,
        message: getLang({en:"Please enter the number of guests", ar: "يرجى إدخال عدد الضيوف"}, langValue),
      });
    } else if (form.bookingTime === null) {
      alertMessageState({
        type: "error",
        show: true,
        message: getLang({en: "Please select a booking time", ar: "يرجى تحديد وقت الحجز."}, langValue),
      });
    } else if (form.bookingDate === null) {
      alertMessageState({
        type: "error",
        show: true,
        message: getLang({en: "Please select a booking date", ar: "يرجى تحديد تاريخ الحجز"}, langValue),
      });
    } else {
      setBookingForm({
        ...form,
        bookingCategory: bookingCategory,
        b_id: Number(bId),
        slotsType: bookingCategory?.slotsType,
      });
      console.log(
        {
          ...form,
          bookingCategory: bookingCategory,
          b_id: Number(bId),
          slotsType: bookingCategory?.slotsType,
        },
        "booking forms",
        selectionType
      );
      if (bookingCategory?.hasExtras) {
        navigate(`/${slug}/step-2?bId=${bId}`);
      } else {
        setCart([]);
        navigate(`/${slug}/step3?bId=${bId}`);
      }
    }
  };

  const handleCustomGuest = (min: number, max: number) => {
    let guestArr = [];
    for (var i = min > 1 && min != max ? min : 1; i <= max; i++) {
      let data = {
        id: `${i}_id`,
        name: `${i} Guest`,
        value: i,
      };
      guestArr.push(data);
    }
    return guestArr;
  };

  const handleClickGuest = (id: any, value: number | string) => {
    let formData: any = { ...formFields };
    if (formData?.NoGuest == value) {
      formData = {
        ...formData,
        NoGuest: null,
      };
      if (formFields?.bookingTime == null && formFields.bookingDate == null) {
        setGuest(subTotalGuest);
      }
    } else if (
      !(
        formFields?.bookingTime?.maxGuest >= value &&
        formFields?.bookingTime?.minGuest <= value
      )
    ) {
      formData = {
        ...formData,
        // bookingTime: null,
        NoGuest: value,
      };
      // settimeValue(null)
    } else {
      formData = {
        ...formData,
        NoGuest: value,
      };
    }

    setFormFields(formData);
  };

  const handleTimeChange = (id: any) => {
    // Use the current guest state directly
    let formData: any = { ...formFields };
    // Find the corresponding time data based on id
    let filterTime: {} | any = times.find((item: any) => item.id == id);

    if (timeValue == id) {
      settimeValue(-1);
      // Update guest state
      formData = {
        ...formData,
        bookingTime: null,
        bookingTimeInd: -1,
      };

      setGuest(subTotalGuest);
    } else {
      settimeValue(id);
      formData = { ...formData, bookingTime: filterTime, bookingTimeInd: id };
    }
    setFormFields(formData);
  };
 
  

  useEffect(() => {
    if (appState.storeList) {
      let foundSlot = slotsList.find((item: any) => item?.b_id == bId);
      if (foundSlot) {
        handleCurrentSlot(foundSlot);
      }
    }
  }, [appState?.storeList]);

  const handleCurrentSlot = (data: any) => {
    let slotRes: any = [];
    slotRes.push(data?.slots);
    if (data) {
      let bookingCategory = bookingDetails.find((item: any) => item?.id == bId);
      if (bookingCategory?.typeId) {
        setSelectionType(bookingCategory?.typeId);
        setStartAt(bookingCategory?.startAt ?? "");
        setEndAt(bookingCategory?.endAt ?? "");
      }
      setSlots(slotRes);
      let dayArr: any = [];
      let timeArr: any = [];
      let min: number = 0;
      let max: number = 1;
      slotRes.forEach((ele: any) => {
        if (ele?.active) {
          if (min < ele?.guest?.from && min == 0 && min != null) {
            min = ele?.guest?.from;
          } else {
            min = min;
          }

          if (max < ele?.guest?.to && max != null) {
            max = ele?.guest?.to;
          } else {
            max = 10;
          }

          ele?.days.forEach((day: any) => {
            if (dayArr.length > 0) {
              if (
                !dayArr.some((checkEle: any) => checkEle?.id == ele?.day?.id)
              ) {
                dayArr.push({
                  ...day,
                  minGuest: ele?.guest?.from,
                  maxGuest: ele?.guest?.to,
                  type: bookingCategory?.typeId,
                  startAt: bookingCategory?.startAt,
                  endAt: bookingCategory?.endAt,
                });
              }
            } else {
              dayArr.push({
                ...day,
                type: bookingCategory?.typeId,
                minGuest: ele?.guest?.from,
                maxGuest: ele?.guest?.to,
                startAt: bookingCategory?.startAt,
                endAt: bookingCategory?.endAt,
              });
            }
          });
        }
      });

      setDays(dayArr);
      // Input array

      let guestArr: any = [];
      if (min > 0) {
        guestArr = handleCustomGuest(min, max);
      }
      setSubTotalGuest(guestArr);
      setGuest(guestArr);
    }
  };
  useEffect(() => {
    if (bookingDetails.length > 0) {
      if (bId) {
        if (slotsList) {
          let foundSlot = slotsList.find((item: any) => item?.b_id == bId);
          if (foundSlot) {
            handleCurrentSlot(foundSlot);
          }
        }
        setFormFields({
          NoGuest: 0,
          bookingTime: null,
          bookingDayObj: null,
          bookingDate: null,
        });
        setSelectedDate(null);
        let findIndex = bookingDetails.findIndex(
          (item: any) => item.id == Number(bId)
        );
        sethHsExtras(bookingDetails[findIndex]?.hasExtras);
        setValue(Number(findIndex));
      }
    }

    if (bookingForm?.bookingTime) {
      if (bookingForm?.b_id == bId) {
        settimeValue(bookingForm.bookingTimeInd);
        setFormFields({
          NoGuest: bookingForm?.NoGuest,
          bookingTime: bookingForm?.bookingTime,
          bookingTimeInd: bookingForm?.bookingTimeInd,
          bookingDayObj: bookingForm?.bookingDayObj,
          bookingDate: bookingForm?.bookingDate,
          checkBoxDate: bookingForm?.checkBoxDate,
          currentSelectedDate: dayjs(bookingForm?.currentSelectedDate),
          b_id: bookingForm.b_id,
        });
      }
    }
  }, [bId, slotsList]);

  // useEffect(() => {
  //   let { NoGuest, bookingTime, bookingDate } = formFields;
  //   let dayArr: any = [];
  //   let timeArr: any = [];
  //   let min: number = 0;
  //   let max: number = 1;

  //   if (initalMount) {
  //     setInitalMount(false);
  //   } else {
  //     if (bookingDate == null && bookingTime == null) {
  //       let findFromSlot = slots.filter(
  //         (item: any) =>
  //           NoGuest >= item?.guest?.from && NoGuest <= item?.guest?.to
  //       );
  //       if (findFromSlot.length > 0) {
  //         findFromSlot.forEach((ele: any) => {
  //           if (ele?.active) {
  //             if (min < ele?.guest?.from) {
  //               min = ele?.guest?.from;
  //             }
  //             if (max < ele?.guest?.to) {
  //               max = ele?.guest?.to;
  //             }
  //             if (dayArr.length > 0) {
  //               let findDay = dayArr.find(
  //                 (item: any) => item?.id == ele?.day?.id
  //               );
  //               if (findDay == undefined) {
  //                 let data: any = {
  //                   ...ele?.day,
  //                   minGuest: ele?.guest?.from,
  //                   maxGuest: ele?.guest?.to,
  //                   type: selectionType,
  //                 };
  //                 dayArr.push(data);
  //               } else {
  //                 if (findDay) {
  //                   findDay.minGuest =
  //                     findDay.minGuest > ele?.guest?.from
  //                       ? ele?.guest?.from
  //                       : findDay.minGuest;
  //                   findDay.maxGuest =
  //                     findDay.maxGuest < ele?.guest?.to
  //                       ? ele?.guest?.to
  //                       : findDay.maxGuest;
  //                 }
  //               }
  //             } else {
  //               let data: any = {
  //                 ...ele?.day,
  //                 type: selectionType,
  //                 minGuest: ele?.guest?.from,
  //                 maxGuest: ele?.guest?.to,
  //               };
  //               dayArr.push(data);
  //             }

  //             if (timeArr.length > 0) {
  //               let findTime = timeArr.find(
  //                 (item: any) => item?.id == ele?.time?.id
  //               );
  //               if (findTime == undefined) {
  //                 let data: any = {
  //                   ...ele?.time,
  //                   slotId: ele?.id,
  //                   minGuest: ele?.guest?.from,
  //                   maxGuest: ele?.guest?.to,
  //                 };
  //                 timeArr.push(data);
  //               } else {
  //                 if (findTime) {
  //                   findTime.minGuest =
  //                     findTime.minGuest > ele?.guest?.from
  //                       ? ele?.guest?.from
  //                       : findTime.minGuest;
  //                   findTime.maxGuest =
  //                     findTime.maxGuest < ele?.guest?.to
  //                       ? ele?.guest?.to
  //                       : findTime.maxGuest;
  //                 }
  //               }

  //               let checkTime = timeArr.find(
  //                 (checkEle: any) => checkEle?.id == ele?.time?.id
  //               );
  //               if (checkTime) {
  //                 if (checkTime?.maxGuest < ele?.guest?.to) {
  //                   checkTime.maxGuest = ele?.guest?.to;
  //                 }
  //                 if (checkTime?.minGuest > ele?.guest?.from) {
  //                   checkTime.minGuest = ele?.guest?.from;
  //                 }
  //               }
  //             } else {
  //               let data: any = {
  //                 ...ele?.time,
  //                 slotId: ele?.id,
  //                 minGuest: ele?.guest?.from,
  //                 maxGuest: ele?.guest?.to,
  //               };
  //               timeArr.push(data);
  //             }
  //           }
  //         });
  //         // setDays(dayArr);
  //         let guestArr: any = [];
  //         if (min > 0) {
  //           guestArr = handleCustomGuest(min, max);
  //         }
  //         setSubTotalGuest(guestArr);
  //         setGuest(guestArr);
  //       }
  //     } else if (bookingTime == null && selectionType != 1) {
  //       let dayObj = formFields?.bookingDayObj;
  //       let findFromSlot = slots.filter(
  //         (item: any) =>
  //           // NoGuest >= item?.guest?.from &&
  //           // NoGuest <= item?.guest?.to &&
  //           item?.day?.id == dayObj?.id
  //       );
  //       findFromSlot.forEach((ele: any) => {
  //         if (ele?.active) {
  //           if (min < ele?.guest?.from) {
  //             min = ele?.guest?.from;
  //           }
  //           if (max < ele?.guest?.to) {
  //             max = ele?.guest?.to;
  //           }
  //           if (timeArr.length > 0) {
  //             let findTime = timeArr.find(
  //               (item: any) => item?.id == ele?.time?.id
  //             );
  //             if (findTime == undefined) {
  //               let data: any = {
  //                 ...ele?.time,
  //                 slotId: ele?.id,
  //                 minGuest: ele?.guest?.from,
  //                 maxGuest: ele?.guest?.to,
  //               };
  //               timeArr.push(data);
  //             } else {
  //               if (findTime) {
  //                 findTime.minGuest =
  //                   findTime.minGuest > ele?.guest?.from
  //                     ? ele?.guest?.from
  //                     : findTime.minGuest;
  //                 findTime.maxGuest =
  //                   findTime.maxGuest < ele?.guest?.to
  //                     ? ele?.guest?.to
  //                     : findTime.maxGuest;
  //               }
  //             }
  //             let checkTime = timeArr.find(
  //               (checkEle: any) => checkEle?.id == ele?.time?.id
  //             );
  //             if (checkTime) {
  //               if (checkTime?.maxGuest < ele?.guest?.to) {
  //                 checkTime.maxGuest = ele?.guest?.to;
  //               }
  //               if (checkTime?.minGuest > ele?.guest?.from) {
  //                 checkTime.minGuest = ele?.guest?.from;
  //               }
  //             }
  //           } else {
  //             let data: any = {
  //               ...ele?.time,
  //               slotId: ele?.id,
  //               minGuest: ele?.guest?.from,
  //               maxGuest: ele?.guest?.to,
  //             };
  //             timeArr.push(data);
  //           }
  //         }
  //       });
  //       let guestArr: any = [];
  //       // if (min > 0) {
  //       guestArr = handleCustomGuest(min, max);
  //       // }

  //       setSubTotalGuest(guestArr);
  //       setGuest(guestArr);
  //     }
  //   }
  // }, [formFields?.NoGuest, formFields.bookingTime, formFields?.bookingDate]);

  useEffect(() => {
    setBId(searchParams.get("bId"));
  }, [searchParams]);

  const isRtl = langValue === "ar";

  const guestChipOptions = guest?.map((item: any) => ({
    id: item.value,
    label: `${item.value} ${t("custom-msg.guest")}`,
  }));

  const timeChipOptions = times?.map((item: any) => ({
    id: item.id,
    label:
      slug === "kul-kuwait-city"
        ? convertTo12HourFormat(item?.starting)
        : `${convertTo12HourFormat(item?.starting)} - ${convertTo12HourFormat(item?.ending)}`,
    disabled: formFields?.NoGuest > item.maxGuest || !item?.has_space,
  }));

  return (
    <React.Fragment>
      <div id="guest-slots-new">
      {routeLoading && <FreezScreen />}

      {apiLoading ? (
        <div className="py-2 px-2">
          <div className="col-md-12 px-0">
            <Skeleton height={100} />
          </div>
          <div className="col-md-12 px-0">
            <Skeleton height={100} />
          </div>
        </div>
      ) : (
        <BookingStepSection
          step={1}
          title={t("custom-msg.Select-Date")}
          icon="📅"
          rtl={isRtl}
        >
          <BasicDatePicker
            type={selectionType}
            start_At={startAt}
            end_At={endAt}
            data={days}
            label={`${t("custom-msg.Select-Date")}`}
            selectedDate={formFields?.currentSelectedDate ?? null}
            handleDateChange={handleDateChange}
            reservation={formFields}
            langValue={langValue}
            excludedDates={excludedDates}
            maxDays={maxDays}
          />
        </BookingStepSection>
      )}

      {apiLoading ? (
        <div className="py-3 px-2">
          <Skeleton height={30} width={140} />
          <Skeleton height={50} className="mt-2" />
        </div>
      ) : (
        <BookingStepSection
          step={2}
          title={t("custom-msg.How-many-Guests")}
          icon="👥"
          rtl={isRtl}
        >
          <SelectionChipGrid
            options={guestChipOptions}
            selectedId={formFields?.NoGuest || null}
            onSelect={(id) => {
              const guestItem = guest.find((g: any) => g.value === id);
              if (guestItem) handleClickGuest(guestItem.id, guestItem.value);
            }}
            rtl={isRtl}
          />
        </BookingStepSection>
      )}

      {apiLoading ? (
        ""
      ) : (
        <BookingStepSection
          step={3}
          title={t("custom-msg.Arrival-time")}
          icon="🕐"
          rtl={isRtl}
          className="mb-5 pb-3"
        >
          <SelectionChipGrid
            options={timeChipOptions}
            selectedId={timeValue !== -1 ? timeValue : null}
            onSelect={handleTimeChange}
            rtl={isRtl}
            emptyMessage={t("Please select a booking date")}
          />
        </BookingStepSection>
      )}
      <NewNextBtn
        label={`${t("custom-msg.Next")} `}
        handleCheckout={handleNext}
        disBtn={apiLoading}
      />

      {/* <BtnNext label="Next" handleCheckout={handleNext} /> */}
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(GuestSlotsNew);
